import { useEffect } from "react";
import { useDispatch } from "react-redux";

const ErrorFallback = ({ error, resetErrorBoundary }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    resetErrorBoundary();
  }, []);
  return (
    <div role="alert">
      <p>Something went wrong:</p>
      <pre>{error.message}</pre>
      <button onClick={resetErrorBoundary}>Try again</button>
    </div>
  );
};
export default ErrorFallback;
